module.exports = "<div class=\"nav-item\" routerLinkActive=\"active\">\n\t<a routerLink=\"/config/enrich\">Enrich</a>\n</div>\n<div class=\"nav-item\" routerLinkActive=\"active\">\n\t<a routerLink=\"/config/workflows\">Workflows</a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/config/config-nav/config-nav.component.html
// module id = ./client/app/config/config-nav/config-nav.component.html
// module chunks = main